import { render, staticRenderFns } from "./model-viewer.vue?vue&type=template&id=5bd9bf56"
import script from "./model-viewer.vue?vue&type=script&lang=js"
export * from "./model-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports